import { LAYER_KEY } from '../layer';
import { unByKey } from 'ol/Observable';

import Control from 'ol/control/Control';

class AbstractLayerEntry {
	constructor(layer) {
		this.layer = layer.layer
		this.source = layer.source;
		this.instance = layer;
		this.eventKeys = [];
	}
		
	listen( eventKey ) {
		this.eventKeys.push( eventKey );
	}
		
	remove() {
		this.eventKeys.forEach(unByKey);	
	}
	
}

class AbstractLayerControl extends Control {

	constructor(opt_options) {
	    const options = opt_options ? opt_options : {};	
		super({
      		element: document.createElement('div'),
      		render: options.render,
      		target: options.target
    	});	
	
		this.layers = {};		
	}
	
	setMap(map) {
		super.setMap(map);
		
		if( map ) { 
			map.getLayers().on('add', ({element}) => {
				const layer = element.get(LAYER_KEY);
				if( this.acceptLayer(layer) ) {
					this.addLayer(layer);				
				}
			});
		
			map.getLayers().on('remove', ({element}) => {
				const layer = element.get(LAYER_KEY);
				if( this.acceptLayer(layer) ) {
					this.removeLayer(layer);
				}
			});	
		}
	}	
	
	acceptLayer( source ) {
		return true;
	}
	
	addLayer(layer) {
		const uuid = layer.layer.ol_uid;
		this.deleteLayer(uuid);
		
		this.layers[uuid] = this.createEntry(layer);
		this.refresh();
	}
	
	createEntry( layer ) {
		return new AbstractLayerEntry(layer);
	}
	
	removeLayer(layer) {
		const uuid = layer.layer.ol_uid;	
		this.deleteLayer(uuid);
		this.refresh();	
	}	
	
	getLayers() {
		 return Object.keys(this.layers)
			.map(key => this.layers[key]);
	}
	
	refresh() {
			
	}
	
	deleteLayer(uuid) {	
		if( this.layers.hasOwnProperty(uuid) ){ 
			this.layers[uuid].remove();
			delete this.layers[uuid];	
		}
	}		
	
}

export {
	AbstractLayerControl, AbstractLayerEntry
}

